const URLS = {
  //Authentication api
  GetAdminLogin: `/admin/login`,
  GetAdmin: "/admin/",
  DeactiveAdmin: "/deactivate",
  ActivateAdmin: "/activate",
  ProfileUser: "/profile",
  PasswordUSer: "/password",

  //User apis
  GetDriver: "get-drivers-list/",
  GetDriverCount: "/get-driver-count",
  GetPassenger: "get-passenger-list/",
  CreateDriver: "register-driver",
  UpdateDriver: "update-driver/",
  AddVehicleToDriver: "add-vehicle-to-driver/",
  CreatePassenger: "register-passenger",
  UpdatePassenger: "update-passenger/",
  DeleteDriver: "delete-driver/",
  DeletePassenger: "delete-passenger/",
  GetActiveDrivers: "get-active-drivers/",
  UpdateDriverStatus: "update-driver-account-status/",
  GetDriverByVehicle: "get-driver-by-vehicle/",

  GetPasswordReset: "/passwordRest",
  GetPasswordChange: "/auth/profile/change-password/",
  updateUserData: "/auth/profile/update/",
  CreateOwnerProfile: "/auth/ownerprofile/create/",
  UpdateOwnerProfile: "/auth/ownerprofile/update/",
  GetOwner: "/auth/owners/",
  GetUserList: "/auth/users/",

  //payment
  GetAdminPaymentHistory: "/admin_payment_history/",
  GetPaymentByID: "/payment_history/:id",
  CreateDepositeToWallet: "/deposit_wallet",
  CreateRidePayment: "/ride_payment",
  GetDriverPaymentByID: "/get_driver_payment/",
  GetDriverPaymentHistory: "/driver_payment_history/",

  //Payment Type
  GetPaymentTypes: "payment-types",

  // 🧾 ADMIN ROUTES
  GetAdminSummary: "/get_admin_summary",
  UpdatePyment: "/update_payment/:id",
  DeletePayment: "/delete_payment/:id",

  // Vehicle Apis
  GetVehicle: "get-vehicle-list/", //tested
  GetVehicleListByID: "get-vehicle-by-id/", //tested
  GetVehicleListPlateNo: "/vehicle/by-plate/",
  GetVehicleListOwner: "/vehicle/by-owner/",
  GetVehicleRestore: "/vehicle/restore/",
  GetVehicleCreate: "add-vehicle/", //testing
  GetUpdateVehicle: "/vehicleUpdate",
  GetVehicleDelete: "/vehicleDelete/",
  GetDriverByName: "search-drivers-no-vehicles/",
  UpdateInsuranceStatus: "update-vehicle-insurance-status/",

  //Vehicle insurance
  GetVehicleInsurance: "/vehicle-insurance/",
  GetVehicleInsurancebyVehicle: "/vehicle-insurance/by-vehicle/",

  //Vehicle type
  GetVehicleType: "get-vehicle-type/",
  GetVehicleTypebyVehicle: "/vehicle-value/by-vehicle/",
  AddVehicleType: "/add-vehicle-type/",

  GetNotification: "/notifications/",

  //Notification webSocke
  NotificationWeb: "/ws/notifications/",

  //Ride Apis
  GetRides: "get-ride-list/",
  GetRidesByID: "get-rides-for-driver/",
  GetRidesByStatus: "get-ride-by-status/",

  //Document and Type Apis
  GetDocumentType: "get-doc-type-list/",
  CreateDocument: "create-document/",
  GetDriverDocument: "get-doc-type-list/",

  //Service Category
  GetServiceCategory: "get-service-list/",
  CreateServiceCategory: "create-service-category/",
  GetCategoryName: "get-service-name/",
};

export { URLS };
